import React from 'react';
import { string } from 'prop-types';

import classnames from 'classnames';
import { Image } from 'nordic/image';

import { FilterLink } from '../../link';

const namespace = 'ui-search-vehicle-body-item';

/**
 * VehicleBodyItem component renders a list item with a link, image, and name for a vehicle body.
 *
 * @component
 * @param {Object} props - Component properties.
 * @param {string} [props.image] - URL of the image to display.
 * @param {string} props.id - Unique identifier for the vehicle body.
 * @param {string} props.name - Name of the vehicle body.
 * @param {string} props.url - URL to link to for the vehicle body.
 * @returns {JSX.Element} The rendered component.
 */
const VehicleBodyItem = ({ id, url, name, image }) => (
  <li className={namespace}>
    <FilterLink className={`${namespace}__link`} href={url} title={name}>
      <div className={`${namespace}__image-container`}>
        <div className={`${namespace}__overlay-image`} />
        {image && (
          <Image
            preload
            mounted
            carousel
            className={classnames(`${namespace}__image`, `ui-search-vehicle-body-image--${id}`)}
            src={image}
            alt=""
          />
        )}
      </div>
      <h3 className={`${namespace}__name`}>{name}</h3>
    </FilterLink>
  </li>
);

VehicleBodyItem.propTypes = {
  id: string.isRequired,
  image: string.isRequired,
  name: string.isRequired,
  url: string.isRequired,
};

export default VehicleBodyItem;
